/* ==========================================================================
   RAIKI - Galeria con scroll fijado
   Sprint 01 · revisado 26-ago (segunda pasada)

   QUE PASA AQUI, en orden:
     1. la pantalla se queda fija
     2. las piezas cruzan de IZQUIERDA A DERECHA en tres niveles de
        profundidad, cada uno a su velocidad
     3. la frase entra tambien desde la izquierda y aterriza al 60% del
        recorrido
     4. en cuanto aterriza, el impacto: un rayo barre, revientan seis rayos
        por la pantalla y hay un destello
     5. el resto del recorrido las piezas siguen pasando

   POR QUE EL IMPACTO NO VA ENGANCHADO AL SCROLL:
   todo lo demas si lo esta (scrub), pero un flash enganchado al scroll se
   arrastra al ritmo de la rueda del raton y deja de ser un flash. El impacto
   se dispara en tiempo real cuando el recorrido cruza el 60%, y se rearma si
   el visitante sube por encima del 52%.

   TRES NIVELES DE PROFUNDIDAD:
     lejos   z0  lento   pequeno, desenfocado, apagado
     fondo   z1  medio   por DETRAS de la frase
     (frase) z2
     frente  z3  rapido  por DELANTE de la frase, mas grande y con sombra
   La diferencia de velocidad es lo que crea la sensacion de distancia.

   LOS CINCO ESCOLLOS DE "pin" QUE ADVIERTE LA DOCUMENTACION:
   1. No animar el elemento fijado. Fijamos .raiki-pin__fijo y animamos solo
      sus hijos. Animar el propio elemento fijado descuadra las mediciones.
   2. Crear los ScrollTrigger en orden de aparicion en la pagina.
   3. Transforms o will-change en un ancestro rompen el fijado. La seccion no
      lleva ninguna transformacion propia.
   4. Nada de content-visibility: auto en el disparador.
   5. pinnedContainer si el disparador vive dentro de otro fijado. No aplica.
   ========================================================================== */

(function () {
  'use strict';

  // Cuanto recorre cada nivel, en % del ancho de la ventana.
  // Todos empiezan a la IZQUIERDA (negativo) y terminan a la derecha.
  var NIVELES = [
    { sel: '.raiki-pin__capa--lejos', desde: -22, hasta: 14 },
    { sel: '.raiki-pin__capa--fondo', desde: -42, hasta: 26 },
    { sel: '.raiki-pin__capa--frente', desde: -66, hasta: 42 },
  ];

  // De donde entra cada linea de la frase. Distancias distintas para que no
  // parezca un bloque solido deslizandose: llegan juntas pero se ve que cada
  // una viene de mas o menos lejos.
  var DESDE_LINEA = [-150, -115, -180];

  // En que punto del recorrido aterriza la frase. El impacto va justo despues.
  var ATERRIZA = 0.6;

  /* En telefono el mismo desfile, con recorridos mas cortos: la ventana es
     angosta, asi que el mismo porcentaje recorre muchos menos pixeles y las
     piezas se irian de pantalla antes de que se las vea. */
  var NIVELES_MOVIL = [
    { sel: '.raiki-pin__capa--lejos',  desde: -16, hasta: 10 },
    { sel: '.raiki-pin__capa--fondo',  desde: -32, hasta: 20 },
    { sel: '.raiki-pin__capa--frente', desde: -50, hasta: 32 }
  ];

  /* Cuanto scroll consume el efecto en telefono, en % del alto de la ventana.
     Es el numero que decide si "hay que arrastrar mucho el dedo": con 70 el
     desfile entero pasa en menos de una pantalla de scroll. */
  var RECORRIDO_MOVIL = 70;

  function montarImpacto(fijo) {
    var rayo = fijo.querySelector('.raiki-pin__rayo');
    var destello = fijo.querySelector('.raiki-pin__destello');
    var chispas = fijo.querySelectorAll('.raiki-pin__chispa');
    if (!rayo && !destello && !chispas.length) return null;

    var flash = gsap.timeline({ paused: true });

    // El rayo barre la pantalla.
    if (rayo) {
      flash
        .set(rayo, { opacity: 1 }, 0)
        .fromTo(rayo, { xPercent: -130 }, { xPercent: 330, duration: 0.42, ease: 'power2.in' }, 0)
        .to(rayo, { opacity: 0, duration: 0.16 }, 0.32);
    }

    // Los rayos aparecen DE GOLPE, sin entrada. Eso es lo que los hace leer
    // como electricidad y no como elementos animandose.
    if (chispas.length) {
      chispas.forEach(function (ch, i) {
        var t = 0.3 + i * 0.022;
        var giro = (i % 2 === 0 ? 1 : -1) * (8 + i * 3);
        flash
          .set(ch, { opacity: 1, rotate: giro, scale: 1 }, t)
          .set(ch, { opacity: 0 }, t + 0.05)
          .set(ch, { opacity: 1, scale: 1.18 }, t + 0.09)
          .to(ch, { opacity: 0, scale: 0.9, duration: 0.3, ease: 'power2.out' }, t + 0.16);
      });
    }

    if (destello) {
      flash
        .to(destello, { opacity: 0.34, duration: 0.05, ease: 'none' }, 0.3)
        .to(destello, { opacity: 0, duration: 0.34, ease: 'power2.out' }, 0.36);
    }

    return flash;
  }

  /* EN TELEFONO: LAS PIEZAS ENTRAN, PERO LA PANTALLA NO SE FIJA.

     El fijado sigue descartado en movil por la razon de siempre: pelea con el
     gesto de scroll del sistema y se siente trabado. Pero apagarlo entero
     dejaba la seccion completamente quieta, y las piezas cruzando son la
     seccion. Se separan las dos cosas, que no son la misma: el RECORRIDO
     (las piezas apareciendo desde la izquierda) se conserva, el PIN se
     descarta.

     Es una revelacion al entrar en pantalla y no un scrub: enganchado al
     scroll obligaria a calcular un recorrido que en telefono no existe,
     porque la seccion ya no consume alto extra.

     from y nunca to, como todo el resto del tema: si GSAP no carga, las
     piezas quedan en su sitio y visibles.                                  */
  function montarMovil(seccion) {
    // Hace falta la clase: sin ella el CSS fuerza "transform: none !important"
    // sobre las piezas y pisaria lo que escriba GSAP. Y ademas es la que
    // enciende el modo desfile en la hoja de estilos.
    seccion.classList.add('raiki-pin--js');

    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: seccion,
        start: 'top 88%',
        end: '+=' + RECORRIDO_MOVIL + '%',
        // Enganchado al scroll, como en escritorio: las piezas siguen al dedo.
        // El 0.35 le da un pelo de inercia para que no se vea escalonado en
        // pantallas que reportan el scroll a saltos.
        scrub: 0.35,
        invalidateOnRefresh: true
      }
    });

    NIVELES_MOVIL.forEach(function (n) {
      var capa = seccion.querySelector(n.sel);
      if (!capa) return;
      tl.fromTo(capa, { xPercent: n.desde }, { xPercent: n.hasta, ease: 'none', duration: 1 }, 0);
    });

    // La frase entra desde la izquierda y frena, igual que en escritorio, pero
    // aterriza antes: en telefono el recorrido es mas corto y si llegara al
    // 60% quedaria a medio camino cuando la seccion ya salio de pantalla.
    var lineas = seccion.querySelectorAll('.raiki-pin__linea');
    lineas.forEach(function (linea, i) {
      tl.fromTo(linea,
        { xPercent: DESDE_LINEA[i % DESDE_LINEA.length] / 2 },
        { xPercent: 0, ease: 'power2.out', duration: 0.5 }, 0);
    });

    // Ya se puede destapar: los fromTo escribieron el estado inicial al
    // crearse, asi que quitar la clase no produce parpadeo.
    seccion.classList.remove('raiki-pin--preparado');
    seccion.classList.remove('raiki-pin--destapando');
  }

  function iniciar() {
    // Sin movimiento por peticion del visitante: no fijamos nada y el CSS
    // deja la seccion como grilla legible.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    if (typeof window.gsap === 'undefined' || typeof window.ScrollTrigger === 'undefined') return;

    gsap.registerPlugin(ScrollTrigger);

    var esMovil = window.matchMedia('(max-width: 749px)').matches;

    document.querySelectorAll('.raiki-pin[data-pin="on"]').forEach(function (seccion) {
      if (esMovil) {
        if (seccion.dataset.montado === 'true') return;
        seccion.dataset.montado = 'true';
        montarMovil(seccion);
        return;
      }
      montarEscritorio(seccion);
    });

    window.addEventListener('load', function () {
      ScrollTrigger.refresh();
    });
  }

  function montarEscritorio(seccion) {
    if (seccion.dataset.montado === 'true') return;
    seccion.dataset.montado = 'true';

    var fijo = seccion.querySelector('.raiki-pin__fijo');
    if (!fijo) return;

    // Avisa al CSS que el guion tomo el control, para que abandone el modo
    // grilla de reserva y pase al modo fijado.
    seccion.classList.add('raiki-pin--js');

    var recorrido = parseInt(seccion.dataset.recorrido, 10) || 170;
    var flash = montarImpacto(fijo);
    var yaSono = false;

    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: seccion,
        start: 'top top',
        end: '+=' + recorrido + '%',
        pin: fijo,
        pinSpacing: true,
        scrub: 1,
        invalidateOnRefresh: true,
        onUpdate: function (self) {
          if (!flash) return;
          if (self.progress > ATERRIZA + 0.02 && !yaSono) {
            yaSono = true;
            flash.restart();
          } else if (self.progress < ATERRIZA - 0.08 && yaSono) {
            yaSono = false;
          }
        },
      },
    });

    // Los tres niveles recorren toda la seccion, cada uno su distancia.
    // Duracion explicita de 1 para que la linea de tiempo mida 1 y los
    // porcentajes de mas abajo signifiquen lo que dicen.
    NIVELES.forEach(function (n) {
      var capa = seccion.querySelector(n.sel);
      if (!capa) return;
      tl.fromTo(capa, { xPercent: n.desde }, { xPercent: n.hasta, ease: 'none', duration: 1 }, 0);
    });

    // La frase entra desde la izquierda y frena. Todas las lineas aterrizan
    // a la vez: es UN momento de llegada, no tres, porque el impacto que
    // viene despues tiene que tener una sola causa.
    var lineas = seccion.querySelectorAll('.raiki-pin__linea');
    lineas.forEach(function (linea, i) {
      tl.fromTo(
        linea,
        { xPercent: DESDE_LINEA[i % DESDE_LINEA.length] },
        { xPercent: 0, ease: 'power2.out', duration: ATERRIZA },
        0,
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  // El editor de temas remonta la seccion al editarla.
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target || !e.target.querySelector('.raiki-pin')) return;
    if (typeof ScrollTrigger !== 'undefined') {
      ScrollTrigger.getAll().forEach(function (t) {
        t.kill();
      });
    }
    var s = e.target.querySelector('.raiki-pin');
    if (s) s.dataset.montado = 'false';
    iniciar();
  });
})();
